export const makeid = (length:number, pattern: string | null) => {
    var result = ''
    var characters = pattern || 'ABCDEF123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
      charactersLength))
    }
    return result
  }